import React, { useState } from 'react';
import { motion } from "framer-motion";
import Logo from "../assets/mainlogo.png";

const NavBar = () => {
  const [activeLink, setActiveLink] = useState("#");
  const [showMenu, setShowMenu] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleMenuClick = (section) => {
    setActiveLink(section);
    document.querySelector(section).scrollIntoView({ behavior: "smooth" });
    toggleMenu();
  };

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const anim = {
    open: { opacity: 1, x: 0 },
    closed: { opacity: 0, x: "-100%" },
  };

  return (
    <motion.div className="navbar">
      <div className="nav-logo-div">
        <img alt="TheBooker Logo" src={Logo} />
        <p>TheBooker</p>
      </div>

      <div className="nav-links-div">
        <a
          onClick={() => setActiveLink("#")}
          href="#"
          style={{
            borderBottom: activeLink === "#" ? "2px solid black" : "none",
          }}
        >
          HOME
        </a>
        <a href="#users" style={{ margin: "0 50px" }}>
          USERS
        </a>
        <a href="#business" style={{ marginRight: 0 }}>
          BUSINESS
        </a>
        <a href="#subscription" style={{ marginLeft: "30px" }}>
          SUBSCRIPTIONS
        </a>
        <div className="dropdown-container" onMouseEnter={handleDropdownToggle}>
          <a href="#" style={{ margin: "0 30px" }}>
            BLOG
          </a>
          {showDropdown && (
            <div className="dropdown-menu">
              <a
                href="/blog/5-Benefits-of-having-a-system-for-personal-care-business"
                target="_blank"
              >
                5 Benefits of Having a Booking System for Personal Care
                Businesses
              </a>
              <a href="/blog/embracing-personal-care-together" target="_blank">
                Embracing Personal Care Together
              </a>
            </div>
          )}
        </div>

        <div className="subscribe-btn" style={{ marginLeft: 0 }}>
          <p onClick={() => window.location.replace("#NewsPaper")}>DOWNLOAD</p>
        </div>
      </div>

      <motion.div
        className={`nav-burger-menu ${showMenu ? "active" : ""}`}
        onClick={toggleMenu}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <div className="bar1"></div>
        <div className="bar2"></div>
        <div className="bar3"></div>
      </motion.div>

      <motion.div
        className="menu-layout"
        initial="closed"
        animate={showMenu ? "open" : "closed"}
        variants={anim}
      >
        <div className="nav-links-div">
          <a
            onClick={() => setActiveLink("#")}
            href="#"
            style={{
              borderBottom: activeLink === "#" ? "2px solid black" : "none",
            }}
          >
            HOME
          </a>
          <a onClick={() => handleMenuClick("#users")} href="#users">
            USERS
          </a>
          <a onClick={() => handleMenuClick("#business")} href="#business">
            BUSINESS
          </a>
          <a
            onClick={() => handleMenuClick("#subscription")}
            href="#subscription"
          >
            SUBSCRIPTIONS
          </a>
          <div className="dropdown-container">
            <a href="#" onTouchStart={handleDropdownToggle}>
              BLOG
            </a>
            {showDropdown && (
              <div className="dropdown-menu">
                <a
                  href="/blog/5-Benefits-of-having-a-system-for-personal-care-business"
                  target="_blank"
                  rel="noreferrer"
                >
                  5 Benefits of Having a Booking System for Personal Care
                  Businesses
                </a>
                <a
                  href="/blog/embracing-personal-care-together"
                  target="_blank"
                  rel="noreferrer"
                >
                  Embracing Personal Care Together
                </a>
              </div>
            )}
          </div>
          <div className="subscribe-btn">
            <p onClick={() => window.location.replace("/store")}>DOWNLOAD</p>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default NavBar;
